// ----------------------------------------------------------------------

export default function Skeleton(theme) {
    return {
        MuiSkeleton: {
            defaultProps: {
                animation: 'wave'
            },
            styleOverrides: {
                root: ({ownerState, theme}) => {
                    return {
                        backgroundColor: theme.palette.background.neutral,
                        maxWidth: '100%'
                    }
                },
            },
        },
    };
}
